module.exports = __webpack_public_path__ + "img/calzedonia-group-logo.bd558f31.png";